import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import './chatmemberitem.scss';

const ChatMemberItem = ({ ...props }) => {
  const { sb, status, name, id } = props;
  const [onlineStatus, setOnlineStatus] = useState(status);

  const userStatus = user => {
    const ApplicationUserListQuery = sb.createApplicationUserListQuery();
    ApplicationUserListQuery.userIdsFilter = [user];
    ApplicationUserListQuery.next((users, error) => {
      if (error) {
        return 'offline';
      }
      setOnlineStatus(users[0].connectionStatus);
      return 'online';
    });
  };

  useEffect(() => {
    setInterval(() => {
      userStatus(id);
    }, 10000);
  }, []);

  return (
    <div className={`chat-member-name ${onlineStatus}`}>
      <span className="chat-member-status" />
      {name}
    </div>
  );
};

ChatMemberItem.propTypes = {
  status: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  sb: PropTypes.shape().isRequired,
};

export default ChatMemberItem;
